var _g, _g2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserOutlineCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1546_260)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 35,
    r: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 35,
    r: 34.5,
    stroke: "#2EBA88",
    strokeDasharray: "2 2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1546_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 52.04L18.12 56.9226C17.5947 57.2091 17.1226 57.5611 16.6833 57.9449C21.9022 62.3453 28.6392 65 36 65C43.3064 65 50.0003 62.3849 55.2045 58.0445C54.7245 57.6392 54.2037 57.2747 53.6264 56.9872L44.0411 52.1951C42.8026 51.5759 42.0203 50.3102 42.0203 48.9257V45.1649C42.2898 44.8581 42.5977 44.4642 42.9271 43.9989C44.2335 42.1536 45.2218 40.1238 45.9067 37.9943C47.1362 37.6151 48.0418 36.4796 48.0418 35.1302V31.1159C48.0418 30.2328 47.649 29.4438 47.0388 28.8913V23.0883C47.0388 23.0883 48.2309 14.0577 36.0011 14.0577C23.7713 14.0577 24.9633 23.0883 24.9633 23.0883V28.8913C24.352 29.4438 23.9603 30.2328 23.9603 31.1159V35.1302C23.9603 36.1875 24.5162 37.1181 25.3483 37.6559C26.3513 42.0223 28.9777 45.1649 28.9777 45.1649V48.8328C28.9766 50.1687 28.2452 51.3992 27.0713 52.04Z",
    fill: "#E7ECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5128 5.00453C19.9471 4.72151 6.28749 17.9215 6.00447 34.4872C5.84372 43.88 10.0301 52.3219 16.6958 57.9358C17.1316 57.5555 17.5992 57.2068 18.1188 56.9238L27.0701 52.0411C28.2441 51.4004 28.9754 50.1698 28.9754 48.8317V45.1638C28.9754 45.1638 26.3479 42.0211 25.346 37.6547C24.515 37.117 23.9581 36.1875 23.9581 35.1291V31.1147C23.9581 30.2317 24.3509 29.4426 24.9611 28.8902V23.0872C24.9611 23.0872 23.769 14.0566 35.9988 14.0566C48.2286 14.0566 47.0365 23.0872 47.0365 23.0872V28.8902C47.6479 29.4426 48.0396 30.2317 48.0396 31.1147V35.1291C48.0396 36.4785 47.1339 37.614 45.9045 37.9932C45.2196 40.1226 44.2313 42.1525 42.9248 43.9977C42.5954 44.463 42.2875 44.857 42.0181 45.1638V48.9245C42.0181 50.3091 42.8003 51.5758 44.0388 52.194L53.6241 56.986C54.1992 57.2736 54.7188 57.637 55.1977 58.0411C61.6618 52.6502 65.8381 44.5898 65.9931 35.5128C66.2784 18.9472 53.0796 5.28755 36.5128 5.00453Z",
    fill: "#556080"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9191 73.5122C37.9191 74.8462 36.834 75.9313 35.5 75.9313C34.166 75.9313 33.0813 74.8462 33.0813 73.5122C33.0813 72.1782 34.166 71.093 35.5 71.093C36.834 71.093 37.9191 72.1786 37.9191 73.5122ZM43 70.0771V76.9481C43 77.8641 42.2573 78.6067 41.3414 78.6067H29.6586C28.7427 78.6067 28 77.8641 28 76.9481V70.0771C28 69.1611 28.7427 68.4185 29.6586 68.4185H31.6988V67.8446C31.6988 67.043 32.3482 66.3933 33.1501 66.3933H37.8499C38.6518 66.3933 39.3012 67.043 39.3012 67.8446V68.4181H41.3414C42.2573 68.4185 43 69.1611 43 70.0771ZM39.1631 73.5122C39.1631 71.4924 37.5198 69.8491 35.5 69.8491C33.4806 69.8491 31.8373 71.4924 31.8373 73.5122C31.8373 75.532 33.4806 77.1753 35.5 77.1753C37.5198 77.1753 39.1631 75.532 39.1631 73.5122Z",
    fill: "#03416B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1546_260",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1546_260"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1546_260",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1546_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutlineCamera);
export default __webpack_public_path__ + "static/media/user-outline-camera.e5211b84c02f570f4715fa152a5bcb5d.svg";
export { ForwardRef as ReactComponent };